import { PageHero } from "../components/site/PageHero";
import { AboutSection } from "../components/home/AboutSection";
import { GovernanceSection } from "../components/home/GovernanceSection";
import { CtaBanner } from "../components/site/CtaBanner";
import { Reveal } from "../components/site/Reveal";
import { SectionHeading } from "../components/site/SectionHeading";
import { Compass, Shield, Gem } from "lucide-react";
import { Seo } from "../components/site/Seo";

const PILLARS = [
  { Icon: Compass, title: "Our Mission", text: "To empower members to build, scale, and sustain multiple streams of income while creating lasting impact and generational wealth." },
  { Icon: Shield, title: "Our Governance", text: "Defined rules, bylaws, membership standards, accountability, and leadership give members a safe environment to do business together." },
  { Icon: Gem, title: "Our Standard", text: "A private, invite-only community of verified entrepreneurs, investors, founders, business owners, and professionals." },
];

export default function About() {
  return (
    <main data-testid="about-page">
      <Seo
        title="About MST | Multiple Stream Team"
        description="MST is a structured private ecosystem built on trust, governance, and purpose — helping members do business, invest, collaborate, and grow together."
        path="/about"
      />
      <PageHero
        label="About MST"
        title={<>A Network Built on Trust, Governance &amp; Purpose</>}
        text="MST is more than a network — it is a structured private ecosystem designed to help members do business, invest, collaborate, and grow together."
      />
      <section className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeading label="What We Stand For" title="Built to Last. Governed to Protect." />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
            {PILLARS.map(({ Icon, title, text }, i) => (
              <Reveal key={title} delay={i * 0.1} data-testid={`about-pillar-${i}`} className="rounded-2xl border border-[#062541]/10 bg-[#F6F8FA] p-9 hover:shadow-[0_12px_35px_rgba(4,21,37,0.1)] transition-shadow duration-300">
                <div className="w-12 h-12 rounded-full bg-[#006FD6]/10 flex items-center justify-center">
                  <Icon size={22} strokeWidth={1.5} className="text-[#006FD6]" />
                </div>
                <h3 className="mt-6 text-lg font-extrabold text-[#041525]" style={{ fontFamily: "var(--font-heading)" }}>{title}</h3>
                <p className="mt-3 text-sm text-[#6B7280] leading-relaxed">{text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <AboutSection />
      <GovernanceSection />
      <CtaBanner />
    </main>
  );
}
